import React from 'react';
import { Label } from '../../types/labels';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import LabelDisplay from './index';

export default function PartsLabelDisplay({
	labels = [],
	className = '',
	darkMode = false,
}: {
	labels: Label[];
	className?: string;
	darkMode?: boolean;
}) {
	if (nullSafeGet('length', labels) < 1) {
		return null;
	}

	return (
		<div className={`flex flex-row flex-wrap items-center gap-x-4 gap-y-2 ${className}`}>
			{labels.map((tag) => (
				<LabelDisplay tag={tag} key={tag.id} darkMode={darkMode} />
			))}
		</div>
	);
}
